import { bind } from "@react-rxjs/core"
import { combineKeys, createSignal } from "@react-rxjs/utils"
import { combineLatest, map, merge, scan, startWith, tap } from "rxjs"

import { currencyPairs$ } from "@/services/currencyPairs"

import { tearOutState$ } from "./Tile/TearOut/tearOut.state"
import { tile$ } from "./Tile/tile.state"

const [selectedCurrencyInput$, onSelectCurrency] = createSignal<string>()
export { onSelectCurrency }

export const ALL_CURRENCIES = "All"

const [useSelectedCurrency, selectedCurrency$] = bind(
  selectedCurrencyInput$.pipe(startWith(ALL_CURRENCIES)),
  ALL_CURRENCIES,
)
export { useSelectedCurrency }

const [useFilteredCurrencyPairs, filteredCurrencyPairs$] = bind(
  combineLatest([currencyPairs$, selectedCurrency$, tearOutState$]).pipe(
    map(([currencyPairs, selectedCurrency, tearOutState]) => {
      const result = { ...currencyPairs }
      for (const symbol of Object.keys(result)) {
        if (tearOutState[symbol]) {
          delete result[symbol]
        }
      }

      if (selectedCurrency === ALL_CURRENCIES) {
        return Object.values(result)
      }

      Object.keys(currencyPairs)
        .filter((symbol) => !symbol.includes(selectedCurrency as string))
        .forEach((symbol) => {
          delete result[symbol]
        })

      return Object.values(result)
    }),
  ),
)
export { useFilteredCurrencyPairs }

export const tiles$ = merge(
  filteredCurrencyPairs$,
  combineKeys(currencyPairs$.pipe(map(Object.keys)), tile$),
)

export enum TileView {
  Normal = "Normal",
  Chart = "Chart",
}
const [toggleSelectedView$, onToggleSelectedView] = createSignal()
export { onToggleSelectedView }

export const SELECTED_VIEW_KEY = "selectedView"

export const getInitView = () =>
  (window.localStorage.getItem(SELECTED_VIEW_KEY) as TileView) || TileView.Chart

export const [useSelectedTileView] = bind(
  (initView: TileView) =>
    toggleSelectedView$.pipe(
      scan(
        (acc) => (acc === TileView.Normal ? TileView.Chart : TileView.Normal),
        initView,
      ),
      tap((newView) => {
        window.localStorage.setItem(SELECTED_VIEW_KEY, newView)
      }),
    ),
  (initView: TileView) => initView,
)
